(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellarjay-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sj-accordion')) {
    customElements.define('sj-accordion', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.heading = this.querySelector('.sj-accordion__heading');
        if (this.heading) {
          this.fitHeading();
          this.resizeObserver?.disconnect();
          this.resizeObserver = new ResizeObserver(() => {
            if (this.heading.getBoundingClientRect().width !== this.headingWidth) this.fitHeading();
          });
          this.resizeObserver.observe(this.heading);
          this.textObserver?.disconnect();
          this.textObserver = new MutationObserver(() => this.fitHeading());
          this.textObserver.observe(this.heading, { childList: true, subtree: true, characterData: true });
          window.addEventListener('resize', () => this.fitHeading(), options);
          document.fonts.addEventListener('loadingdone', () => this.fitHeading(), options);
          document.fonts.ready.then(() => { if (!options.signal.aborted) this.fitHeading(); });
        }
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const item = event.target.closest('.sj-accordion__item[open]');
          if (!item || !this.contains(item)) return;
          event.preventDefault();
          event.stopPropagation();
          item.open = false;
          item.querySelector('summary').focus();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.sj-accordion__item');
          if (item && this.contains(item)) item.open = true;
        }, options);
      }
      fitHeading() {
        const heading = this.heading;
        const text = heading.querySelector('.sj-accordion__heading-text');
        if (!text) return;
        heading.style.removeProperty('font-size');
        const maximum = parseFloat(getComputedStyle(heading).fontSize);
        const available = heading.getBoundingClientRect().width;
        this.headingWidth = available;
        if (!available) return;
        heading.dataset.fit = '';
        // Measure real glyphs (including inline emphasis), preserving tracking and weight.
        // All trial sizes are applied synchronously before the browser paints.
        if (text.getBoundingClientRect().width <= available) return;
        let low = 0;
        let high = maximum;
        while (high - low > 0.05) {
          const size = (low + high) / 2;
          heading.style.fontSize = `${size}px`;
          if (text.getBoundingClientRect().width > available) high = size;
          else low = size;
        }
        heading.style.fontSize = `${low}px`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.textObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellarjay-divider-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sj-divider')) {
    customElements.define('sj-divider', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        let active = true;
        let hero;
        const group = this.querySelector('.sj-divider__group');
        const seed = group?.firstElementChild.cloneNode(true);
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const button = this.querySelector('button');
        const update = () => {
          if (!active) return;
          const previous = this.closest('.shopify-section')?.previousElementSibling;
          const nextHero = previous?.classList.contains('sj-hero-section') ? previous : null;
          if (hero && hero !== nextHero) hero.style.removeProperty('--sj-divider-height');
          hero = nextHero;
          hero?.style.setProperty('--sj-divider-height', `${this.getBoundingClientRect().height}px`);
          if (!group || !seed?.textContent.trim()) return;
          group.replaceChildren(seed.cloneNode(true));
          const itemWidth = group.firstElementChild.getBoundingClientRect().width;
          if (itemWidth <= 0) return;
          const repeats = reduced.matches ? 1 : Math.max(1, Math.ceil(this.clientWidth / itemWidth));
          for (let i = 1; i < repeats; i++) group.append(seed.cloneNode(true));
          const second = group.nextElementSibling;
          second.replaceChildren(...Array.from(group.children, child => child.cloneNode(true)));
          const width = group.getBoundingClientRect().width;
          this.style.setProperty('--sj-divider-duration', `${width / Math.max(10, Number(this.dataset.speed) || 60)}s`);
          this.toggleAttribute('data-ready', !reduced.matches);
          if (button) button.hidden = reduced.matches;
        };
        const toggle = () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
        };
        const resize = new ResizeObserver(update);
        resize.observe(this);
        reduced.addEventListener('change', update);
        button?.addEventListener('click', toggle);
        document.fonts.ready.then(update);
        update();
        this.cleanup = () => {
          active = false;
          resize.disconnect();
          reduced.removeEventListener('change', update);
          button?.removeEventListener('click', toggle);
          hero?.style.removeProperty('--sj-divider-height');
        };
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
